var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var ClientConfig = /** @class */ (function () {
    function ClientConfig(version, getToken) {
        this.version = version;
        this.getToken = getToken;
    }
    return ClientConfig;
}());
export { ClientConfig };
var AuthorizedClientBase = /** @class */ (function () {
    function AuthorizedClientBase(config) {
        this.config = config;
    }
    AuthorizedClientBase.prototype.transformOptions = function (options) {
        var token = this.config.getToken();
        var version = this.config.version;
        if (!token) {
            Promise.reject("Token is not set");
        }
        if (!version) {
            Promise.reject("version is not set");
        }
        options.headers = __assign(__assign({}, options.headers), { "X-Api-Version": version, Authorization: 'Bearer ' + token });
        return Promise.resolve(options);
    };
    return AuthorizedClientBase;
}());
export { AuthorizedClientBase };
//# sourceMappingURL=authorizedClientBase.js.map